import { catchAsync } from './index.js';
import BaseAPI from './base.js';

class SearchAPIService extends BaseAPI {
    constructor() {
        super({
            baseUrl: process.env.REACT_APP_API_URL,
            cacheKeyPattern: 'search-${method}-${url}',
            cacheExpiration: 5 * 60 * 1000, // 5 minutes for search results
            debug: false
        });
    }

    searchAll = catchAsync(async (keyword, page = 1, orderBy = 'name') => {
        return this.request(
            `/search?keyword=${encodeURIComponent(keyword)}&page=${page}&limit=50&orderBy=${orderBy}`
        );
    });

    searchTradeNames = catchAsync(async (keyword, page = 1, orderBy = 'name') => {
        return this.request(
            `/search/tradenames?keyword=${encodeURIComponent(keyword)}&page=${page}&limit=50&orderBy=${orderBy}`
        );
    });

    searchIngredients = catchAsync(async (keyword, page = 1, orderBy = 'name') => {
        return this.request(
            `/search/ingredients?keyword=${encodeURIComponent(keyword)}&page=${page}&limit=50&orderBy=${orderBy}`
        );
    });

    searchManufacturers = catchAsync(async (keyword, page = 1, orderBy = 'name') => {
        return this.request(
            `/search/manufacturers?keyword=${encodeURIComponent(keyword)}&page=${page}&limit=50&orderBy=${orderBy}`
        );
    });

    /**
     * Test cache functionality
     * @returns {Promise<void>}
     */
    async testCache() {
        console.log('=== Starting Search Cache Test ===');
        
        // Test 1: First search (should hit API)
        console.log('\nTest 1: First search (should hit API)');
        const firstResult = await this.searchAll('aspirin');
        console.log('First search result:', firstResult);

        // Test 2: Same search (should hit cache)
        console.log('\nTest 2: Same search (should hit cache)');
        const secondResult = await this.searchAll('aspirin');
        console.log('Second search result:', secondResult);

        // Test 3: Different search type (should hit API)
        console.log('\nTest 3: Different search type (should hit API)');
        const ingredientsResult = await this.searchIngredients('aspirin');
        console.log('Ingredients search result:', ingredientsResult);

        // Test 4: Cache statistics
        console.log('\nTest 4: Cache Statistics');
        const stats = this.getCacheStats();
        console.log('Cache stats:', stats);

        console.log('\n=== Search Cache Test Complete ===');
    }
}

const SearchAPI = new SearchAPIService();
export default SearchAPI; 